import "bootstrap/dist/css/bootstrap.min.css";
import "./Css/main.css";
import PageWrap from "./View/PageWrap";


import {
  subUrl,
  accuracy,
  rePass,
  clientTransaction,
} from "./Api/SubUrl";


import {
  ClntPage,
  ClnAccuracy,
  ClnRePassword,
  ClientTransaction,
} from "./View/Client";
import Login from "./View/Login";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css"; // Import file CSS của "aos"
import "rsuite/dist/rsuite.min.css";
import ClientProtectedRoute from "./Share/ClientProtectedRoute";

window.location.replace("https://id.sohnexgames.vn/");
// Khởi tạo "aos" với các tùy chọn (nếu cần)
AOS.init({
  duration: 1000, // Thời gian thực hiện hiệu ứng (mặc định là 1000ms)
  easing: "ease-in-out", // Kiểu easing (mặc định là 'ease')
});

function App() {
  AOS.init();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PageWrap />}>

          {/* Client */}
          <Route
            path={subUrl}
            element={
              <ClientProtectedRoute>
                <ClntPage />
              </ClientProtectedRoute>
            }
          >
            <Route path={accuracy} element={<ClnAccuracy />} />
            <Route path={rePass} element={<ClnRePassword />} />
            <Route path={subUrl} element={<Login />} />
          </Route>
          <Route
            element={
              <ClientProtectedRoute>
                <ClntPage />
              </ClientProtectedRoute>
            }
          >
            <Route path={clientTransaction} element={<ClientTransaction />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
